(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cmss-fall-savings"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-cmss-fall-sale]').forEach((promo) => {
        if (promo.dataset.initialized) return;
        promo.dataset.initialized = 'true';
        const parent = promo.closest('.cmss-flagship');
        const fallback = parent && parent.querySelector('[data-cmss-fall-fallback]');
        const promoHeading = promo.querySelector('h1');
        const fallbackHeading = fallback && fallback.querySelector('h1');
        const start = Date.parse(promo.dataset.start);
        const end = Date.parse(promo.dataset.end);
        const publish = (eventName, action) => {
          try {
            const shop = window.Shopify;
            if (promo.dataset.preview === 'true' || !shop || shop.designMode || !shop.customerPrivacy || !shop.customerPrivacy.analyticsProcessingAllowed() || !shop.analytics || typeof shop.analytics.publish !== 'function') return;
            const result = shop.analytics.publish(eventName, {campaign:'fall_savings_oct16_25_2026',action:action});
            if (result && typeof result.catch === 'function') result.catch(() => {});
          } catch (error) {}
        };
        let seen = false;
        const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
          if (!seen && !promo.hidden && entries.some(entry => entry.isIntersecting)) {
            seen = true;
            publish('cmss:promotion_view', 'hero');
          }
        }, {threshold:0.15}) : null;
        if (observer) observer.observe(promo.querySelector('h1'));
        promo.addEventListener('click', (event) => {
          const link = event.target instanceof Element && event.target.closest('a');
          if (!link || promo.hidden) return;
          publish('cmss:promotion_click', link.dataset.promoAction || (link.classList.contains('cmss-fall-sale__primary') ? 'fall_favorites' : 'classroom_supplies'));
        });
        const refresh = () => {
          const now = Date.now();
          const active = promo.dataset.themeRole === 'main' && Number.isFinite(start) && Number.isFinite(end) && now >= start && now < end;
          promo.hidden = !active;
          if (fallback) fallback.hidden = active;
          if (parent && promoHeading && fallbackHeading) parent.setAttribute('aria-labelledby', active ? promoHeading.id : fallbackHeading.id);
          return now < end;
        };
        let timer;
        const tick = () => {
          if (!promo.isConnected) return;
          if (refresh()) timer = setTimeout(tick, 1000);
        };
        tick();
        document.addEventListener('visibilitychange', refresh);
        window.addEventListener('pageshow', refresh);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(promo)) {
            clearTimeout(timer);
            document.removeEventListener('visibilitychange', refresh);
            window.removeEventListener('pageshow', refresh);
          }
        });
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
